import type { IxcPaymentsV1IncomingAchKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const PAYMENTS_INCOMING_ACH_BASE_PATH = getResolvedPath('/clearing/finance/payment/incoming-ach');

export const getPaymentsIncomingAchPath: EntityPathBuilder<IxcPaymentsV1IncomingAchKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return PAYMENTS_INCOMING_ACH_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.achId) {
        return undefined;
      }

      return getResolvedPath(`${PAYMENTS_INCOMING_ACH_BASE_PATH}/$achId`, context.keys);
    }
  }
};

export function getPaymentsIncomingAchDetailPath(achId: string | undefined) {
  if (!achId) {
    return undefined;
  }

  return getPaymentsIncomingAchPath({ kind: 'detail', keys: { achId } });
}
